export default "__VITE_ASSET__CW_OaXu1__"